exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?importLoaders=1!./node_modules/postcss-loader/lib!./node_modules/less-loader/dist/cjs.js!./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/style-loader!./node_modules/css-loader?importLoaders=1&minimize!./node_modules/postcss-loader/lib!./node_modules/less-loader/dist/cjs.js!./src/styles/layout.less
// module id = 606
// module chunks = 2